<template>
    <v-container fluid>
        <v-row justify="center">
            <v-col cols="12">
                <v-card width="100%">
                    <v-card-title class="py-2 primary secondary--text d-block text-center font-weight-bold" style="word-break: normal">
                        <v-icon color="secondary" class="mr-2">mdi-bullhorn-variant</v-icon>
                        CONFIGURACION WEB Y ANUNCIOS
                    </v-card-title>
                    <v-btn bottom color="secondary primary--text" :loading="loading" depressed fab absolute right small @click="getData">
                        <v-icon>mdi-sync</v-icon>
                    </v-btn>
                </v-card>
            </v-col>
        </v-row>

        <v-row justify="center">
            <v-col cols="12">
                <v-form ref="form" @submit.prevent="submit" lazy-validation v-model="valid">
                    <v-card>
                        <v-progress-linear indeterminate fixed v-if="loading" style="top:0"/>
                        <v-card-text>
                            <v-alert dense outlined color="primary" class="mb-4">
                                Estos campos se cargan solo en navegador web. No se inyectan en Android ni iOS.
                            </v-alert>

                            <v-row dense>
                                <v-col cols="12">
                                    <v-card outlined>
                                        <v-card-title class="subtitle-1 font-weight-bold">
                                            <v-icon color="primary" class="mr-2">mdi-power</v-icon>
                                            Estado general
                                            <v-spacer/>
                                            <v-switch
                                                v-model="form.enabled"
                                                inset
                                                dense
                                                hide-details
                                                color="success"
                                                :disabled="loading"/>
                                        </v-card-title>
                                        <v-card-text>
                                            <v-list dense color="transparent" class="pa-0">
                                                <v-list-item>
                                                    <v-list-item-icon>
                                                        <v-icon color="primary">mdi-web</v-icon>
                                                    </v-list-item-icon>
                                                    <v-list-item-content>
                                                        <v-list-item-title>Solo version web</v-list-item-title>
                                                        <v-list-item-subtitle>Las apps usan sus integraciones nativas y no cargan estos scripts.</v-list-item-subtitle>
                                                    </v-list-item-content>
                                                </v-list-item>
                                                <v-list-item>
                                                    <v-list-item-icon>
                                                        <v-icon :color="activeIntegrationsCount ? 'success' : 'grey'">mdi-check-decagram</v-icon>
                                                    </v-list-item-icon>
                                                    <v-list-item-content>
                                                        <v-list-item-title>{{ activeIntegrationsCount }} integracion(es) listas</v-list-item-title>
                                                        <v-list-item-subtitle>Se activa cada una solamente si tiene ID y el interruptor encendido.</v-list-item-subtitle>
                                                    </v-list-item-content>
                                                </v-list-item>
                                            </v-list>
                                        </v-card-text>
                                    </v-card>
                                </v-col>

                                <v-col cols="12" md="6" xl="4">
                                    <v-card outlined class="fill-height">
                                        <v-card-title class="subtitle-1 font-weight-bold">
                                            <v-icon color="primary" class="mr-2">mdi-chart-timeline-variant</v-icon>
                                            Microsoft Clarity
                                            <v-spacer/>
                                            <v-chip small :color="integrationReady('clarity', 'project_id') ? 'success' : 'grey'" dark>
                                                {{ integrationReady('clarity', 'project_id') ? 'Listo' : 'Pendiente' }}
                                            </v-chip>
                                        </v-card-title>
                                        <v-card-text>
                                            <v-switch v-model="form.clarity.enabled" inset dense color="success" label="Activar Clarity" :disabled="loading"/>
                                            <v-text-field
                                                v-model="form.clarity.project_id"
                                                outlined
                                                dense
                                                label="Project ID"
                                                prepend-inner-icon="mdi-identifier"
                                                hint="Se toma de Settings > Setup en Clarity."
                                                persistent-hint
                                                :error-messages="errors['clarity.project_id']"/>
                                        </v-card-text>
                                    </v-card>
                                </v-col>

                                <v-col cols="12" md="6" xl="4">
                                    <v-card outlined class="fill-height">
                                        <v-card-title class="subtitle-1 font-weight-bold">
                                            <v-icon color="primary" class="mr-2">mdi-google-analytics</v-icon>
                                            Google Tag
                                            <v-spacer/>
                                            <v-chip small :color="integrationReady('google_tag', 'tag_id') ? 'success' : 'grey'" dark>
                                                {{ integrationReady('google_tag', 'tag_id') ? 'Listo' : 'Pendiente' }}
                                            </v-chip>
                                        </v-card-title>
                                        <v-card-text>
                                            <v-switch v-model="form.google_tag.enabled" inset dense color="success" label="Activar Google Tag" :disabled="loading"/>
                                            <v-text-field
                                                v-model="form.google_tag.tag_id"
                                                outlined
                                                dense
                                                label="Tag ID"
                                                prepend-inner-icon="mdi-tag"
                                                hint="Ejemplos comunes: G-..., GT-... o AW-..."
                                                persistent-hint
                                                :error-messages="errors['google_tag.tag_id']"/>
                                        </v-card-text>
                                    </v-card>
                                </v-col>

                                <v-col cols="12" md="6" xl="4">
                                    <v-card outlined class="fill-height">
                                        <v-card-title class="subtitle-1 font-weight-bold">
                                            <v-icon color="primary" class="mr-2">mdi-google-ads</v-icon>
                                            Google Ads
                                            <v-spacer/>
                                            <v-chip small :color="integrationReady('google_ads', 'conversion_id') ? 'success' : 'grey'" dark>
                                                {{ integrationReady('google_ads', 'conversion_id') ? 'Listo' : 'Pendiente' }}
                                            </v-chip>
                                        </v-card-title>
                                        <v-card-text>
                                            <v-switch v-model="form.google_ads.enabled" inset dense color="success" label="Activar Google Ads" :disabled="loading"/>
                                            <v-text-field
                                                v-model="form.google_ads.conversion_id"
                                                outlined
                                                dense
                                                label="Conversion ID"
                                                prepend-inner-icon="mdi-target"
                                                hint="Normalmente empieza por AW-."
                                                persistent-hint
                                                :error-messages="errors['google_ads.conversion_id']"/>
                                            <v-text-field
                                                v-model="form.google_ads.conversion_label"
                                                outlined
                                                dense
                                                label="Conversion label"
                                                prepend-inner-icon="mdi-label-outline"
                                                hint="Opcional, para conversiones puntuales."
                                                persistent-hint
                                                :error-messages="errors['google_ads.conversion_label']"/>
                                        </v-card-text>
                                    </v-card>
                                </v-col>

                                <v-col cols="12" md="6" xl="4">
                                    <v-card outlined class="fill-height">
                                        <v-card-title class="subtitle-1 font-weight-bold">
                                            <v-icon color="primary" class="mr-2">mdi-google-circles-communities</v-icon>
                                            Google Tag Manager
                                            <v-spacer/>
                                            <v-chip small :color="integrationReady('google_tag_manager', 'container_id') ? 'success' : 'grey'" dark>
                                                {{ integrationReady('google_tag_manager', 'container_id') ? 'Listo' : 'Pendiente' }}
                                            </v-chip>
                                        </v-card-title>
                                        <v-card-text>
                                            <v-switch v-model="form.google_tag_manager.enabled" inset dense color="success" label="Activar Tag Manager" :disabled="loading"/>
                                            <v-text-field
                                                v-model="form.google_tag_manager.container_id"
                                                outlined
                                                dense
                                                label="Container ID"
                                                prepend-inner-icon="mdi-code-tags"
                                                hint="Empieza por GTM-."
                                                persistent-hint
                                                :error-messages="errors['google_tag_manager.container_id']"/>
                                        </v-card-text>
                                    </v-card>
                                </v-col>

                                <v-col cols="12" md="6" xl="4">
                                    <v-card outlined class="fill-height">
                                        <v-card-title class="subtitle-1 font-weight-bold">
                                            <v-icon color="primary" class="mr-2">mdi-cash-multiple</v-icon>
                                            Google AdSense
                                            <v-spacer/>
                                            <v-chip small :color="integrationReady('adsense', 'publisher_id') ? 'success' : 'grey'" dark>
                                                {{ integrationReady('adsense', 'publisher_id') ? 'Listo' : 'Pendiente' }}
                                            </v-chip>
                                        </v-card-title>
                                        <v-card-text>
                                            <v-switch v-model="form.adsense.enabled" inset dense color="success" label="Activar AdSense" :disabled="loading"/>
                                            <v-text-field
                                                v-model="form.adsense.publisher_id"
                                                outlined
                                                dense
                                                label="Publisher ID"
                                                prepend-inner-icon="mdi-identifier"
                                                hint="Acepta pub-... o ca-pub-..."
                                                persistent-hint
                                                :error-messages="errors['adsense.publisher_id']"/>
                                        </v-card-text>
                                    </v-card>
                                </v-col>

                                <v-col cols="12" md="6" xl="4">
                                    <v-card outlined class="fill-height">
                                        <v-card-title class="subtitle-1 font-weight-bold">
                                            <v-icon color="primary" class="mr-2">mdi-facebook</v-icon>
                                            Meta Pixel
                                            <v-spacer/>
                                            <v-chip small :color="integrationReady('meta_pixel', 'pixel_id') ? 'success' : 'grey'" dark>
                                                {{ integrationReady('meta_pixel', 'pixel_id') ? 'Listo' : 'Pendiente' }}
                                            </v-chip>
                                        </v-card-title>
                                        <v-card-text>
                                            <v-switch v-model="form.meta_pixel.enabled" inset dense color="success" label="Activar Meta Pixel" :disabled="loading"/>
                                            <v-text-field
                                                v-model="form.meta_pixel.pixel_id"
                                                outlined
                                                dense
                                                label="Pixel o Dataset ID"
                                                prepend-inner-icon="mdi-identifier"
                                                hint="Lo entrega Meta Events Manager."
                                                persistent-hint
                                                :error-messages="errors['meta_pixel.pixel_id']"/>
                                        </v-card-text>
                                    </v-card>
                                </v-col>
                            </v-row>

                            <v-expansion-panels class="mt-4">
                                <v-expansion-panel>
                                    <v-expansion-panel-header>
                                        <span class="font-weight-bold"><v-icon color="primary" class="mr-2">mdi-text-box-edit</v-icon>Informacion general</span>
                                    </v-expansion-panel-header>
                                    <v-expansion-panel-content>
                                        <ckeditor v-model="form.info" :editorUrl="editorUrl" :config="editorConfig"/>
                                    </v-expansion-panel-content>
                                </v-expansion-panel>
                            </v-expansion-panels>

                            <v-row justify="center">
                                <v-col cols="12" sm="6" md="4">
                                    <v-btn type="submit" class="mt-6" block large :loading="loading" color="success" :disabled="loading || !valid">
                                        <v-icon left>mdi-content-save</v-icon>Guardar configuracion
                                    </v-btn>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                </v-form>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import axios from 'axios';
    import Form from "../../../helpers/form";

    export default {
        name: "Ads",
        mixins: [Form],
        props: [ 'user' ],
        data: () => ({
            loading: false,
            labels: {
                info: 'Informacion General'
            },
            form: {
                info: null,
                enabled: false,
                clarity: {
                    enabled: false,
                    project_id: ''
                },
                google_tag: {
                    enabled: false,
                    tag_id: ''
                },
                google_ads: {
                    enabled: false,
                    conversion_id: '',
                    conversion_label: ''
                },
                google_tag_manager: {
                    enabled: false,
                    container_id: ''
                },
                adsense: {
                    enabled: false,
                    publisher_id: ''
                },
                meta_pixel: {
                    enabled: false,
                    pixel_id: ''
                }
            },
            editorUrl: 'https://cdn.ckeditor.com/4.22.1/full-all/ckeditor.js',
            editorConfig: {
                toolbarGroups: [
                    { name: 'document', groups: [ 'mode', 'document', 'doctools' ] },
                    { name: 'clipboard', groups: [ 'clipboard', 'undo' ] },
                    { name: 'editing', groups: [ 'find', 'selection', 'spellchecker', 'editing' ] },
                    { name: 'forms', groups: [ 'forms' ] },
                    '/',
                    { name: 'colors', groups: [ 'colors' ] },
                    { name: 'basicstyles', groups: [ 'basicstyles', 'cleanup' ] },
                    { name: 'paragraph', groups: [ 'list', 'indent', 'blocks', 'align', 'bidi', 'paragraph' ] },
                    '/',
                    { name: 'links', groups: [ 'links' ] },
                    { name: 'insert', groups: [ 'insert' ] },
                    { name: 'styles', groups: [ 'styles' ] },
                    { name: 'tools', groups: [ 'tools' ] },
                    { name: 'others', groups: [ 'others' ] },
                    { name: 'about', groups: [ 'about' ] }
                ],
                removeButtons: 'Save,NewPage,Preview,Print,Templates,Flash,Maximize,ShowBlocks,About',
                removeDialogTabs: 'image:advanced;link:advanced',
                autoParagraph: false,
                format_tags: 'p;h1;h2;h3;h4;h5;h6;pre;address;div',
                extraAllowedContent: 'span;ul;li;table;th;td;center;br;style;*[id];*(*);*{*}',
                resize_enabled: false,
                enterMode: 'CKEDITOR.ENTER_P',
                shiftEnterMode: 'CKEDITOR.ENTER_BR',
                toolbarCanCollapse: true,
                language: 'es',
                height: '300'
            }
        }),
        computed: {
            activeIntegrationsCount() {
                return [
                    this.integrationReady('clarity', 'project_id'),
                    this.integrationReady('google_tag', 'tag_id'),
                    this.integrationReady('google_ads', 'conversion_id'),
                    this.integrationReady('google_tag_manager', 'container_id'),
                    this.integrationReady('adsense', 'publisher_id'),
                    this.integrationReady('meta_pixel', 'pixel_id')
                ].filter(Boolean).length;
            }
        },
        created () {
            this.getData();
        },
        methods: {
            getData() {
                this.loading = true;

                Promise.all([
                    axios.get('/api/settings/ads'),
                    axios.get('/api/settings/web/integrations')
                ]).then(([ads, integrations]) => {
                    this.form.info = ads.data.info;
                    this.applyIntegrationPayload(integrations.data);
                }).catch(err => {
                    this.handleRequestError(err, 'No fue posible cargar la configuracion.');
                }).then(() => {
                    this.loading = false;
                });
            },
            submit() {
                if (!this.$refs.form.validate()) {
                    return;
                }

                this.loading = true;

                Promise.all([
                    axios.post('/api/settings/ads', { info: this.form.info }),
                    axios.post('/api/settings/web/integrations', this.integrationPayload())
                ]).then(([, integrations]) => {
                    this.applyIntegrationPayload(integrations.data.settings || integrations.data);
                    this.$toast.success('La configuracion se actualizo correctamente.', {icon: 'mdi-check-circle'});
                }).catch(err => {
                    this.handleRequestError(err, 'No fue posible guardar la configuracion.');
                }).then(() => {
                    this.loading = false;
                });
            },
            integrationReady(group, field) {
                return !!(this.form[group] && this.form[group].enabled && this.form[group][field]);
            },
            integrationPayload() {
                return {
                    enabled: !!this.form.enabled,
                    clarity: Object.assign({}, this.form.clarity),
                    google_tag: Object.assign({}, this.form.google_tag),
                    google_ads: Object.assign({}, this.form.google_ads),
                    google_tag_manager: Object.assign({}, this.form.google_tag_manager),
                    adsense: Object.assign({}, this.form.adsense),
                    meta_pixel: Object.assign({}, this.form.meta_pixel)
                };
            },
            applyIntegrationPayload(payload) {
                const current = this.integrationPayload();
                const merged = Object.assign({}, current, payload || {});

                this.form.enabled = !!merged.enabled;
                this.form.clarity = Object.assign({}, current.clarity, merged.clarity || {});
                this.form.google_tag = Object.assign({}, current.google_tag, merged.google_tag || {});
                this.form.google_ads = Object.assign({}, current.google_ads, merged.google_ads || {});
                this.form.google_tag_manager = Object.assign({}, current.google_tag_manager, merged.google_tag_manager || {});
                this.form.adsense = Object.assign({}, current.adsense, merged.adsense || {});
                this.form.meta_pixel = Object.assign({}, current.meta_pixel, merged.meta_pixel || {});
            },
            handleRequestError(err, fallback) {
                const response = err && err.response ? err.response : null;

                if (response && response.data && response.data.errors) {
                    this.handleErrors(response.data.errors);
                    return;
                }

                this.$toast.error((response && response.data && response.data.status) || fallback, {icon: 'mdi-alert-circle'});
            }
        }
    }
</script>
